/**
 * Plugins & Skills, under the organization — `/$org/connections`, matching
 * `$org/compliance` and `$org/inbox`. The org segment keeps the selected
 * tenant visible in the URL and makes the page bookmarkable per org.
 *
 * @module routes/$org.connections
 */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useEffect } from "react";

import { ConnectionsPage } from "../components/connections/ConnectionsPage";
import { recordVisitedOrg, useActiveOrgId, useOrgs } from "../state/orgs";

function ConnectionsRouteView() {
  const activeOrgId = useActiveOrgId();
  const { orgs } = useOrgs();
  // Visiting an org's plugins keeps it the active tenant, matching inbox.
  useEffect(() => {
    if (activeOrgId && orgs.some((org) => org.id === activeOrgId)) {
      recordVisitedOrg(activeOrgId);
    }
  }, [activeOrgId, orgs]);
  return <ConnectionsPage />;
}

export const Route = createFileRoute("/$org/connections")({
  beforeLoad: async ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
  },
  component: ConnectionsRouteView,
});
